<template>
  <div id="sso-container">
    <div class="row text-center">
    <h1 style="font-weight: bold;">Connecting ...</h1>
    </div>
    <div class="row & text-center" style="margin-top: 50px">
      <div class="m-b-sm col-sm-2 col-xs-12">
      </div>
      <div class="m-b-sm col-sm-2 col-xs-12">
        <vue-ladda type="button" class="btn btn-info btn-lg btn-outline" title="Linkedin" @click="loginLinkedin()" :loading="linkedinButton.loading" :data-style="linkedinButton.dataStyle"><i class="fab fa-linkedin-in"></i> </vue-ladda>
      </div>
      <div class="m-b-sm col-sm-2 col-xs-12">
        <vue-ladda type="button" class="btn btn-info btn-lg btn-outline" title="Google" @click="loginGoogle()" :loading="googleButton.loading" :data-style="googleButton.dataStyle"><i class="fab fa-google"></i></vue-ladda>
      </div>
      <div class="m-b-sm col-sm-2 col-xs-12">
        <vue-ladda type="button" class="btn btn-info btn-lg btn-outline" title="Facebook" @click="loginFacebook()" :loading="facebookButton.loading" :data-style="facebookButton.dataStyle"><i class="fab fa-facebook-square text-info"></i></vue-ladda>
      </div>
      <div class="m-b-sm col-sm-2 col-xs-12">
        <vue-ladda type="button" class="btn btn-info btn-lg btn-outline" title="Microsoft" @click="loginAzure()" :loading="azureButton.loading" :data-style="azureButton.dataStyle"><i class="fab fa-brands fa-microsoft text-info"></i> </vue-ladda>
      </div>
      <div class="m-b-sm col-sm-2 col-xs-12">
      </div>
    </div>
    <div class="row text-center" style="margin-top: 50px">
      <div class="col-xs-6 col-xs-offset-3 col-md-4 col-md-offset-4">
        <router-link v-if="from === 'Login'" class="btn btn-info btn-block" :to="{name: 'Login'}">Sign In with email</router-link>
        <router-link v-else class="btn btn-info btn-block" :to="{name: 'Register'}">Sign Up with email</router-link>
      </div>
    </div>
  </div>
</template>
<style scoped>
#sso-container {
  max-width: 720px;
  margin: auto;
}
</style>
<script>

import VueCookies from 'vue-cookies'
import VueLadda from 'vue-ladda'

export default {
  components: {VueLadda},
  name: 'SsoConnection',
  props: {
    provider: {
      default: null
    }
  },
  data () {
    return {
      from: 'Login',
      googleButton: {
        loading: false,
        dataStyle: 'zoom-in'
      },
      linkedinButton: {
        loading: false,
        dataStyle: 'zoom-in'
      },
      facebookButton: {
        loading: false,
        dataStyle: 'zoom-in'
      },
      azureButton: {
        loading: false,
        dataStyle: 'zoom-in'
      }
    }
  },
  methods: {
    loginGoogle: function () {
      this.$auth.oauth2({
        provider: 'google',
        rememberMe: true,
        params: {
          state: 'google'
        }
      })
    },
    loginLinkedin: function () {
      window.location.href = process.env.LOGIN_LINKEDIN_URL
    },
    loginFacebook: function () {
      window.location.href = process.env.LOGIN_FACEBOOK_URL
    },
    loginAzure: function () {
      window.location.href = process.env.LOGIN_AZURE_URL
    },
    connectUsingGoogle (code) {
      let goal = localStorage.getItem('goal')
      goal = goal !== null ? '&goal=' + encodeURI(goal) : ''

      this.googleButton.loading = true
      this.axios.get('/auth/google/callback?code=' + code + goal)
        .then((response) => {
          this.$auth.token(null, response.data.access_token)
          VueCookies.set('rememberMe', true)
          localStorage.setItem('is_already_connect', 'true')
          this.$auth.watch.data = response.data.data // user object
          this.$auth.watch.authenticated = true

          this.googleButton.loading = false
          if (this.from === 'Login') {
            this.$salesMachine.signIn()
          } else {
            this.$salesMachine.signUp()
          }
          this.redirectAfterLogin()
        })
        .catch((resp) => {
          this.ssoConnexionError(resp)
          this.googleButton.loading = false
        })
    },
    connectUsingLinkedin (code) {
      let goal = localStorage.getItem('goal')
      goal = goal !== null ? '&goal=' + encodeURI(goal) : ''

      this.linkedinButton.loading = true
      this.axios.get('/auth/linkedin/callback?code=' + code + goal)
        .then((response) => {
          this.$auth.token(null, response.data.access_token)
          VueCookies.set('rememberMe', true)
          localStorage.setItem('is_already_connect', 'true')
          this.$auth.watch.data = response.data.data // user object
          this.$auth.watch.authenticated = true

          this.linkedinButton.loading = false
          if (this.from === 'Login') {
            this.$salesMachine.signIn()
          } else {
            this.$salesMachine.signUp()
          }
          this.redirectAfterLogin()
        })
        .catch((resp) => {
          this.ssoConnexionError(resp)
          this.linkedinButton.loading = false
        })
    },
    connectUsingFacebook (code) {
      let goal = localStorage.getItem('goal')
      goal = goal !== null ? '&goal=' + encodeURI(goal) : ''

      this.facebookButton.loading = true
      this.axios.get('/auth/facebook/callback?code=' + code + goal)
        .then((response) => {
          this.$auth.token(null, response.data.access_token)
          VueCookies.set('rememberMe', true)
          localStorage.setItem('is_already_connect', 'true')
          this.$auth.watch.data = response.data.data // user object
          this.$auth.watch.authenticated = true

          this.facebookButton.loading = false
          if (this.from === 'Login') {
            this.$salesMachine.signIn()
          } else {
            this.$salesMachine.signUp()
          }
          this.redirectAfterLogin()
        })
        .catch((resp) => {
          this.ssoConnexionError(resp)
          this.facebookButton.loading = false
        })
    },
    connectUsingAzureMicrosoft (code) {
      let goal = localStorage.getItem('goal')
      goal = goal !== null ? '&goal=' + encodeURI(goal) : ''

      this.azureButton.loading = true
      this.axios.get('/auth/azure/callback?code=' + code + goal)
        .then((response) => {
          this.$auth.token(null, response.data.access_token)
          VueCookies.set('rememberMe', true)
          localStorage.setItem('is_already_connect', 'true')
          this.$auth.watch.data = response.data.data // user object
          this.$auth.watch.authenticated = true

          this.azureButton.loading = false
          if (this.from === 'Login') {
            this.$salesMachine.signIn()
          } else {
            this.$salesMachine.signUp()
          }
          this.redirectAfterLogin()
        })
        .catch((resp) => {
          this.ssoConnexionError(resp)
          this.azureButton.loading = false
        })
    },
    ssoConnexionError (resp) {
      if (resp.response && resp.response.status === 400) {
        switch (resp.response.data.code) {
          case 5:
            this.$notify({
              type: 'danger',
              title: 'Oops, connexion failed !',
              content: ' Try again or use another method to connect',
              placement: 'bottom-right'
            })
            break
          case 4:
            this.accountExpired = true
            this.$notify({
              type: 'warning',
              title: 'Oops, your account has expired!',
              content: 'You can reactivate it by contacting us at sales@idexlab.com',
              placement: 'bottom-right'
            })
            break
        }
      }
    },
    redirectAfterLogin () {
      let goTo
      let redirect = localStorage.getItem('redirect')
      let goal = localStorage.getItem('goal')

      if (redirect !== null && redirect !== '/') {
        localStorage.removeItem('redirect')
        if (this.$user.isBasic() && goal === 'topics') {
          goTo = {name: 'Plans'}
          localStorage.setItem('trial', true)
          localStorage.setItem('register_plan', 'silver')
          localStorage.setItem('register_interval', 'm')
          localStorage.setItem('register_redirect', redirect)
        } else {
          goTo = {path: redirect}
        }
      } else {
        let plan = localStorage.getItem('register_plan')
        if (plan && plan !== 'basic' && plan !== 'expert' && this.$user.isSme()) {
          goTo = {name: 'Plans'}
        } else if (this.$user.isSme() && this.$user.isBasic()) {
          goTo = this.$user.isExpert() && !this.$user.hasExpertProfile() ? {name: 'Profile'} : {name: 'Start'}
        } else {
          goTo = {name: 'Dashboard', params: {}}
        }
      }
      this.$router.replace(goTo)
    }
  },
  mounted () {
    $('#sso-container').css('padding-top', ($(window).height() - $('#sso-container').height() - 60) / 2)
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.from = from.name
    })
  },
  beforeMount () {
    if (this.$route.query.redirect) {
      localStorage.setItem('redirect', this.$route.query.redirect)
    }

    if (this.$route.query.goal) {
      localStorage.setItem('goal', this.$route.query.goal)
    }

    if (this.provider !== null) {
      switch (this.provider) {
        case 'google':
          this.loginGoogle()
          break
        case 'facebook':
          this.loginFacebook()
          break
        case 'linkedin':
          this.loginLinkedin()
          break
        case 'azure':
          this.loginAzure()
          break
      }
    }

    if (this.$route.query.code && this.$route.query.state) {
      if (this.$route.query.state === '"google"') {
        this.connectUsingGoogle(this.$route.query.code)
      } else if (this.$route.query.state === 'linkedin') {
        this.connectUsingLinkedin(this.$route.query.code)
      } else if (this.$route.query.state.replace('#_=_', '') === 'facebook') {
        this.connectUsingFacebook(this.$route.query.code)
      } else if (this.$route.query.state === 'azure') {
        this.connectUsingAzureMicrosoft(this.$route.query.code)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/login/SsoConnection.vue